import mosques from './containers/Mosques/routes';
import timetables from './containers/Timetables/routes';
import subscriptions from './containers/Subscriptions/routes';
import adminUsers from './containers/AdminUsers/routes';
import resources from './containers/Resources/routes';
import users from './containers/Users/routes';

const routes = [
    ...mosques,
    ...timetables,
    ...subscriptions,
    ...adminUsers,
    ...resources,
    ...users,
];

export default routes;
